import { safeClone, ViewStream } from "spyne";
import { PageTraits } from "traits/page-traits";

export class PageCallback extends ViewStream {
  constructor(props = {}) {
    props.traits = PageTraits;
    props.data = safeClone(props.pageData);
    props.class = "app-page callback";
    props.isBlog = false;
    props.id = "l1-callback";
    props.channels = ["CHANNEL_AUTH", ["CHANNEL_APP_ROUTE", true]];
    //props.data.contentLen = PageTraits.page$GetContentLength(props.data);
    props.template = "<h1>CALLBACK PAGE</h1>"; // require("./templates/page.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [
      /*
        ["CHANNEL_AUTH_AUTHENTICATION_EVENT", "onChannelAuth"],
*/
      ["CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT", "disposeViewStream"],
    ];
  }

  onChannelAuth(e) {
   //console.log("CHANNEL AUTH ON CALLBACK ", e);

    if (this?.sendInfoToChannel) {
      const action = "CHANNEL_AUTH_CALLBACK_EVENT";
      this.sendInfoToChannel("CHANNEL_AUTH", { action }, action);
    }
  }

  broadcastEvents() {
    return [];
  }

  onRendered() {
    // this.page$CheckToAddCards();
    // this.addChannel("CHANNEL_APP_ROUTE", true);
    // this.page$InitPage();
    //this.page$checkFor404();
  }
}
